@if (form) {

  <div class="flex align-items-center justify-content-center">
    <form class="edit-form mb-8" [formGroup]="form">

      <div class="flex flex-column mx-auto col-12">
        <div class="row">

          <div class="form-item field-wrapper flex align-items-center w-full mb-5">
            <p-float-label>
              <input pInputText
                     id="name"
                     class="gap-4"
                     formControlName="name"
                     maxlength="100"
                     required
                     [pKeyFilter]="ValidationUtils.NAME_PATTERN"
              />
              <label for="name" i18n>Name</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center w-full mb-5">
            <p-float-label>
              <textarea pInputText
                        id="description"
                        class="gap-4"
                        formControlName="description"
                        maxlength="1000"
                        cols="50" rows="5"
              ></textarea>
              <label for="description" i18n>Description</label>
            </p-float-label>
          </div>

          <div class="form-item field-wrapper flex align-items-center w-full mb-5">
            <p-float-label>
              <input pInputText
                     id="title"
                     class="gap-4"
                     formControlName="title"
                     maxlength="100"
                     [pKeyFilter]="ValidationUtils.TITLE_PATTERN"
              />
              <label for="title" i18n>Title</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center w-full mb-5">
            <p-float-label>
              <input pInputText
                     id="baseUrl"
                     class="gap-4"
                     formControlName="baseUrl"
                     maxlength="255"
                     required
              />
              <label for="baseUrl" i18n>URL</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center w-full flex-row mb-5 gap-4">
            <p-float-label>
              <input pInputText
                     id="displayOrder"
                     formControlName="displayOrder"
                     maxlength="10"
                     required
                     [pKeyFilter]="ValidationUtils.NAME_PATTERN"
              />
              <label for="displayOrder" i18n>Display Order</label>
            </p-float-label>

            <p-float-label>
              <input pInputText
                     id="expertCode"
                     formControlName="expertCode"
                     maxlength="10"
                     required
                     [pKeyFilter]="ValidationUtils.NAME_PATTERN"
              />
              <label for="expertCode" i18n>Expert Code</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center w-full flex-row mb-5 gap-4">
              <p-fileupload
                #fileUpload
                mode="basic"
                chooseLabel="Choose Icon"
                chooseIcon="pi pi-upload"
                name="icon"
                accept="image/*"
                maxFileSize="1000000"
                [customUpload]="true"
                [auto]="false"
                [ngClass]="{
                  'p-invalid': form.get('icon')?.invalid && form.get('icon')?.dirty,
                  'p-valid': form.get('icon')?.valid
                }"
                (onSelect)="onUpload($event)"
              />

            @if (application?.icon || currentImage) {
              <p-float-label>
                <img
                  class="chosen-img"
                  [src]="application!.icon ? application!.icon : currentImage"
                  alt="Application Icon" />
              </p-float-label>
            }
          </div>

          <div class="form-item flex align-items-center gap-4 mb-5">
            <label class="bold" for="locked" i18n>Locked</label>
            <p-toggleswitch id="locked" formControlName="locked" />
          </div>

          <p-divider />
          @if (groups?.length) {
            <h3 i18n>Assign Groups</h3>
            <p-pickList
              [source]="availableGroups"
              [target]="assignedGroups"
              sourceHeader="Available"
              targetHeader="Assigned"
              filterBy="displayName"
              sourceFilterPlaceholder="Search by name"
              targetFilterPlaceholder="Search by name"
              [showSourceControls]="false"
              [showTargetControls]="false"
              [dragdrop]="false"
              [responsive]="true"
              [stripedRows]="true"
              [sourceStyle]="{ height: '25rem' }"
              [targetStyle]="{ height: '25rem' }"
              (onMoveToSource)="sortGroups(availableGroups)"
              (onMoveToTarget)="sortGroups(assignedGroups)"
              breakpoint="1400px">
              <ng-template let-group pTemplate="item">
                <span>
                  @if (group.displayName) {
                    {{ group.displayName }}
                  }
                  @else {
                    {{ group.groupId }}
                  }
                </span>
              </ng-template>
            </p-pickList>
          }

          <p-divider />
          <div class="form-item flex align-items-center gap-4 mb-5">
            <label class="bold" for="use-saml" i18n>Use SAML for Authentication</label>
            <p-toggle-switch id="use-saml" (onChange)="clearMessages()" class="positive-pill" formControlName="useSaml" />
          </div>

          @if (form.get('useSaml')?.value) {
            <h3 i18n>SAML Authentication</h3>
            <div class="form-item flex align-items-center gap-4 mb-5">
              <label class="bold my-auto" for="saml-provider-enabled" i18n>Enable Provider</label>
              <p-toggle-switch id="saml-provider-enabled" class="my-auto positive-pill" formControlName="samlProviderEnabled" />
            </div>
            <div class="form-item field-wrapper flex align-items-center w-full mb-5">
              <p-float-label>
                <input pInputText id="saml-acs-url" class="gap-4" formControlName="samlAcsUrl" required>
                <label for="saml-acs-url" i18n>ACS URL</label>
              </p-float-label>
            </div>
            <div class="form-item field-wrapper flex align-items-center w-full mb-5">
              <p-float-label>
                <input pInputText id="saml-acs-validator-pattern" class="gap-4" formControlName="samlAcsValidatorPattern" required>
                <label for="saml-acs-validator-pattern" i18n>ACS Validator Pattern</label>
              </p-float-label>
            </div>
            <div class="form-item field-wrapper flex align-items-center w-full mb-5">
              <p-float-label>
                <p-select id="saml-signature-algorithm" class="gap-4" formControlName="samlSignatureAlgorithm" [options]="signatureAlgorithms"/>
                <label for="saml-signature-algorithm" i18n>Signature Algorithm</label>
              </p-float-label>
            </div>
            <div class="form-item field-wrapper flex align-items-center w-full mb-5">
              <p-float-label>
                <input pInputText id="saml-signature-key" class="gap-4" formControlName="samlSignatureKey">
                <label for="saml-signature-key" i18n>Signature Key</label>
              </p-float-label>
            </div>
            <div class="form-item field-wrapper flex align-items-center w-full mb-5">
              <p-float-label>
                <input pInputText id="saml-signature-password" class="gap-4" type="password" formControlName="samlSignaturePassword">
                <label for="saml-signature-password" i18n>Signature Password</label>
              </p-float-label>
            </div>
            <div class="form-item field-wrapper flex align-items-center w-full mb-5">
              <p-float-label>
                <textarea pTextarea id="saml-encryption-certificate" class="gap-4" rows="5" cols="30" formControlName="samlEncryptionCertificate"></textarea>
                <label for="saml-encryption-certificate" i18n>Encryption Certificate</label>
              </p-float-label>
            </div>
          }

          <div class="flex flex-column my-2">
            @if (messageType) {
              @switch (messageType) {
                @case ('FORM_INVALID') {
                  <p-message severity="error" closable i18n>There are problems with your submission. Please address the fields highlighted in red</p-message>
                }
                @case ('ERROR_SAVING') {
                  <p-message severity="error" closable i18n>An error occurred while saving your changes. Please try again</p-message>
                }
                @case ('CHANGES_SAVED') {
                  <p-message severity="success" closable i18n>Your changes have been saved!</p-message>
                }
                @case ('NOT_UNIQUE') {
                  <p-message severity="error" closable i18n>An application already exists with that expert code. Please try another</p-message>
                }
                @case ('NOT_EXISTS') {
                  <p-message severity="error" closable i18n>This application does not exist. It may have been deleted</p-message>
                }
                @case ('DELETION_CANCELLED') {
                  <p-message severity="info" closable i18n>Application has not been deleted</p-message>
                }
              }
            }
            <div class="form-buttons flex flex-row gap-4 justify-content-between align-items-center">
              @if (editing) {
                <button type="button"
                        class="p-button form-btn warning gap-2 delete"
                        (keydown.enter)="delete($event)"
                        (click)="delete($event)" i18n>
                  Delete
                </button>
              }
              <button type="button"
                      class="p-button form-btn gap-2 save"
                      (keydown.enter)="save()"
                      (click)="save()" i18n>
                Save
              </button>

              <button type="button"
                      class="p-button form-btn secondary cancel gap-2"
                      (keydown.enter)="cancel()"
                      (click)="cancel()" i18n>
                Cancel
              </button>
            </div>
          </div>

          @if (!form.get('useSaml')?.value) {
            <p-divider></p-divider>
            <h3 i18n>Pages</h3>
            @if (pageTree && editing) {
              <div class="tree-table">
                <p-treeTable [tableStyle]="{'max-width':'65rem'}" [value]="pageTree">
                  <ng-template pTemplate="header">
                    <tr>
                      <th id="Display Order">Display Order</th>
                      <th id="Page Name">Name</th>
                      <th id="Title">Title</th>
                      <th id="Expert Code">Expert Code</th>
                      <th id="Active or Locked"></th>
                      <th id="edit">
                        <button class="edit-btn p-button-text p-button-icon-only" pButton type="button"
                                (click)="addPage()">
                          <i class="pi pi-plus"></i>
                        </button>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                    <tr [ttRow]="rowNode">
                      <td>
                        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                        {{ rowData.displayOrder }}
                      </td>
                      <td>{{ rowData.name }}</td>
                      <td>{{ rowData.title || '' }}</td>
                      <td>{{ rowData.expertCode }}</td>
                      <td aria-labelledby="Active or Locked">
                        <i class="pi {{ rowData.locked ? 'pi-lock': 'pi-lock-open' }}"></i>
                      </td>
                      <td class="flex edit-cog" aria-labelledby="edit">
                        <button class="edit-btn p-button-text p-button-icon-only" pButton type="button"
                                (click)="addPage(rowData.id)">
                          <i class="pi pi-plus"></i>
                        </button>
                        <button class="edit-btn p-button-text p-button-icon-only" pButton type="button"
                                (click)="editPage(rowData.id)">
                          <i class="pi pi-cog"></i>
                        </button>
                      </td>
                    </tr>

                  </ng-template>
                </p-treeTable>
              </div>
            } @else {
              <span i18n>Please save the application to create the menu</span>
            }
          }

        </div>
      </div>
      <p-confirmDialog></p-confirmDialog>
    </form>
  </div>
}
